import { TrendingUp } from "@material-ui/icons";
import { App_Roles, AppApprovalPoints, RequestStatus, SpendManagedByData, VendorCategoryData, VendorOnBoardingReasonData, VendorTypeData } from "../constants/AppConstants";
import { UserLoginState } from "../reducers/LoginReducer";
import { Common } from "./Common";
import { User } from "../models/Master/User";
import { UserCompany } from "../models/UserCompany";
import { Approver1n2Data } from "../models/Approval/Approver1n2Data";
import translation from "../i18n/i18.json";
import { MasterDataService } from "../services/MasterDataService";
import { RequestService } from "../services/RequestService";
import { WorkflowApproval } from "../models/WorkflowApproval";

const isInitialVendorDetailMode = (currentPoint:number, requetStatus:number) => {
   if(requetStatus && (requetStatus === RequestStatus.Complete)){
      return false;
   }
   return ((currentPoint === AppApprovalPoints.VCInitial) || (currentPoint === AppApprovalPoints.VCVendorFill))? true:false;
};

const isVendorAprovalEnable = (currentPoint:number, requetStatus:number) => {
   if(Common.isVendor()){
      return false;
   }
   if(requetStatus && (requetStatus == RequestStatus.Complete)){
         return false;
   }
   return ((currentPoint === AppApprovalPoints.VCExCo) || (currentPoint === AppApprovalPoints.VCValidation) || (currentPoint === AppApprovalPoints.VCHoD)
    || (currentPoint === AppApprovalPoints.VCFinnce01) || (currentPoint === AppApprovalPoints.VCCreate) ||  (currentPoint === AppApprovalPoints.VCSupportFinalce)
    || (currentPoint === AppApprovalPoints.VCSupportFinaceHoD) || (currentPoint === AppApprovalPoints.VCBusinessDirector))? true:false;
 };

 const isCallOverVerification = (currentPoint:number, requetStatus:number) => {
   if(requetStatus && (requetStatus === RequestStatus.Complete)){
      return false;
   }
    return (currentPoint === AppApprovalPoints.VCCallBack || currentPoint === AppApprovalPoints.AmendCallover|| currentPoint === AppApprovalPoints.UnblockCallover)? true:false;
 };

 const isCallOverVerificationAny = (currentPoint:number) => {
    return (currentPoint === AppApprovalPoints.VCCallBack || currentPoint === AppApprovalPoints.AmendCallover)? true:false;

 };

 const isSupportDocumentAny = (currentPoint:number) => {
   return (currentPoint === AppApprovalPoints.AmendValidation || currentPoint === AppApprovalPoints.VCValidation)? true:false;

};

const isTeamLeadAny = (currentPoint:number) => {
   return (currentPoint === AppApprovalPoints.AmendCreate || currentPoint === AppApprovalPoints.VCCreate)? true:false;

};

const isSBUSCHeadOrGSSCLead = (currentPoint:number) => {
   return (currentPoint === AppApprovalPoints.VCSBU_SC_HEAD || currentPoint === AppApprovalPoints.VCGSSC_CAT_LEAD || currentPoint === AppApprovalPoints.VASBU_SC_HEAD || currentPoint === AppApprovalPoints.VAGSSC_CAT_LEAD)? true:false;

};


 const isDownloadAttachementEnable = (currentPoint:number) => {
   // return ((currentPoint === AppApprovalPoints.VCInitial) || (currentPoint === AppApprovalPoints.VCVendorFill) || (currentPoint === AppApprovalPoints.VCValidation)
   // ||(currentPoint === AppApprovalPoints.AmendValidation) || (currentPoint === AppApprovalPoints.UnblockValidation))? true:false;
   return true;
};

const getUserPermitedApprovalPoint = (companyCode:string, currentPoints:number[]) => {
   const user:UserLoginState = JSON.parse(Common.getLoginUserData()!);
   const companyCodes = companyCode.split(",");
   let permittedApprovalPoints : number[] = [];
   if(user && user.userCompanies){
      currentPoints.forEach(approvalPointId => {
         let permittedApprovalPoint = approvalPointId;
         companyCodes.forEach(coCode => {
            let userCompany = user.userCompanies.find((c) => { return c.companyCode == coCode; });
            if(!(userCompany && userCompany.approvalPointIds
               && userCompany.approvalPointIds.includes(approvalPointId))){
               permittedApprovalPoint = 0;
            }
         });
         if(permittedApprovalPoint > 0){//return the first matching all companies
            permittedApprovalPoints.push(permittedApprovalPoint);
         }
      });

      // var userCompany = user.userCompanies.find((c) => { return c.companyCode == companyCode; });
      // if(userCompany && userCompany.approvalPointIds){
      //      return currentPoints.find(v => userCompany!.approvalPointIds.includes(v)) || 0;
      // }
   }
   return permittedApprovalPoints.length > 0 ? permittedApprovalPoints[0] : 0;
};

const isUserPermitedApprovalPoint = (companyCode:string, currentPoints:number[]) => {
   let permittedApprovalPoint = getUserPermitedApprovalPoint(companyCode, currentPoints);
   return permittedApprovalPoint && permittedApprovalPoint > 0;
   // const user:UserLoginState = JSON.parse(Common.getLoginUserData()!);
   // if(user && user.userCompanies){
   //    var userCompany = user.userCompanies.find((c) => { return c.companyCode == companyCode; });
   //    if(userCompany && userCompany.approvalPointIds){
   //         return userCompany.approvalPointIds.includes(currentPoint);
   //    }
   // }
   // return false;
};

//TODO : Filter with company code as well
const isUserPermitedRole = (companyCode:string, roleId:number) => {
   const user:UserLoginState = JSON.parse(Common.getLoginUserData()!);
   if(user && user.userCompanies){
      var userCompany = user.userCompanies.find((c) => { return c.companyCode == companyCode; });
      if(userCompany && userCompany.roleIds){
           return userCompany.roleIds.includes(roleId);
      }
   }
   return false;
};

const isRequestApprovable = (companyCode:string, currentPoints:number[], approverNames: string[]) => {
   let user:UserLoginState = JSON.parse(Common.getLoginUserData()!);
   let loggedApprover = (approverNames && user && !user.isVendor)
   ? approverNames.find(an => { return user.email.toUpperCase().includes(an.toUpperCase()) ; })
   : null; 
      
   return loggedApprover && isUserPermitedApprovalPoint(companyCode, currentPoints);
};

const isAdmin = (companyCode:string) => {
   const user:UserLoginState = JSON.parse(Common.getLoginUserData()!);
   if(user && user.userCompanies) {
      var userCompanies =  user.userCompanies.find((c) => { 
            return (!companyCode || c.companyCode == companyCode) && c.approvalPointIds.includes(AppApprovalPoints.Admin);
         }) ;
      return userCompanies ? true : false;
   }
   return false;
}

const isUrgentAproveDisplay = (currentPoint:number) => {
   return ((currentPoint === AppApprovalPoints.VCExCo) || (currentPoint === AppApprovalPoints.VCFinnce01))
   ? true :false;
};

const isRmNonRMService = (vendorTypeCode: string) => {
   return ([VendorTypeData.RMProductionRelated.toString(), VendorTypeData.FixedAssetsConsumables.toString()
      , VendorTypeData.Services.toString(), VendorTypeData.FreightForwarder.toString()].indexOf(vendorTypeCode) > -1 )
      ? true : false;  
};

const isOtherFinaceCreateorAmend = (vendorTypeCode: string, currentPoint:number) => {
   return (!isRmNonRMService(vendorTypeCode)
      && 
      ((currentPoint === AppApprovalPoints.VCFinnce01) || (currentPoint === AppApprovalPoints.AmendFinnce01)))
      ? true:false;
};

// const isRmNonRmServicesCreateorAmend = (vendorTypeCode: string, currentPoint:number) => {
//    return (isRmNonRMService(vendorTypeCode)
//       && 
//       ((currentPoint === AppApprovalPoints.VCFinnce01) || (currentPoint === AppApprovalPoints.AmendFinnce01)))
//       ? true:false;
// };

const isRmNonRMServiceApprover1 = (vendorTypeCode: string, currentPoint:number) => {
   return (isRmNonRMService(vendorTypeCode)
      &&
      ([AppApprovalPoints.VCHoD, AppApprovalPoints.VAHoD, 
        AppApprovalPoints.VCBusinessDirector, AppApprovalPoints.VABusinessDirector, 
        AppApprovalPoints.VCSBU_SC_HEAD, AppApprovalPoints.VASBU_SC_HEAD,
        AppApprovalPoints.VcNmrp_CategoryManager, AppApprovalPoints.VaNmrp_CategoryManager,
        AppApprovalPoints.VcNmrpPillarHead, AppApprovalPoints.VaNmrpPillarHead,
        AppApprovalPoints.VcServicePillarHead, AppApprovalPoints.VaServicePillarHead
      ].indexOf(currentPoint) > -1))
      ? true : false;  

};

const isRmNonRMServiceLegatoTL = (vendorTypeCode: string, currentPoint:number) => {
   return (isRmNonRMService(vendorTypeCode)
      &&
      ([AppApprovalPoints.VCCreate, AppApprovalPoints.VAAmend].indexOf(currentPoint) > -1))
      ? true : false;  

};

const isCheckListApplicable = (vendorType: string, currentPoint:number) => {
   return (currentPoint === AppApprovalPoints.VCValidation 
      || (vendorType == VendorTypeData.RMProductionRelated && currentPoint === AppApprovalPoints.VCCallBack)
      || currentPoint === AppApprovalPoints.VCCreate
      || currentPoint === AppApprovalPoints.AmendValidation
      || (vendorType == VendorTypeData.RMProductionRelated && currentPoint === AppApprovalPoints.AmendCallover)
      || currentPoint === AppApprovalPoints.AmendCreate)? true:false;
};

const isSAPCreateOrAmendOrExtend = (currentPoint:number) => {
   return ((currentPoint === AppApprovalPoints.VCCreate) 
   || (currentPoint === AppApprovalPoints.AmendCreate)
   || (currentPoint === AppApprovalPoints.VEExtendVendor))? true:false;
};

const isCallerVerificationDone = (currentPoint:number) => {
   return ((currentPoint === AppApprovalPoints.VCCreate) || (currentPoint === AppApprovalPoints.VAAmend)) ? true : false;
};

const isOnlyObserver = (coCode : string) => {
   const user:UserLoginState = JSON.parse(Common.getLoginUserData()!);   
   var userCompany =  user.userCompanies.find((c) => { 
            return (!coCode || c.companyCode == coCode) && c.roleIds.includes(App_Roles.Observer) && c.roleIds.length == 1;
         }) ;

   return (userCompany) ? true : false;
};

const isCustomerNominatedOrInnovation = (onBoardingReasonIds: number[]) => {
   return onBoardingReasonIds && (onBoardingReasonIds.find(v => v == VendorOnBoardingReasonData.CustomerNominated 
   || v == VendorOnBoardingReasonData.Innovation)) 
   ? true : false;
}

const isOnboardingReasonAllowed = (onBoardReasonIds: number[], selectedId: number) => {
   return (!(onBoardReasonIds.length > 0) //delete or first value
      || (ApprovalPointUtil.isCustomerNominatedOrInnovation(onBoardReasonIds) && ApprovalPointUtil.isCustomerNominatedOrInnovation([selectedId]))
      || (!ApprovalPointUtil.isCustomerNominatedOrInnovation(onBoardReasonIds) && !ApprovalPointUtil.isCustomerNominatedOrInnovation([selectedId])))
      ? true : false; 
}

// const getApproverRoles = (vendorCategoryId: number, onBoardReasonIds: number[], isBulk: boolean, spendManagedById: number | null ) => {
//    if(vendorCategoryId == VendorCategoryData.RM){
//       if(onBoardReasonIds && onBoardReasonIds.length > 0) {
//          if(isBulk == false && isCustomerNominatedOrInnovation(onBoardReasonIds)) {
//             return [App_Roles.BusinessDirector];
//          } else {
//             return [App_Roles.SBUSCHead, App_Roles.GSSCCategoryLead];
//          }
//       } else {
//          //non VOA vendors default
//          return [App_Roles.SBUSCHead, App_Roles.GSSCCategoryLead];
//       } 
//    } else if(vendorCategoryId == VendorCategoryData.NonRM) {
//       if(spendManagedById == SpendManagedByData.GroupProcurement){
//          return [App_Roles.NMRPPillarLead, App_Roles.NMRPProcurementDirector];
//       } else if(spendManagedById == SpendManagedByData.ProcureM){
//          return [App_Roles.NMRPCategoryManager, App_Roles.NMRPHead];
//       }
//    } else if(vendorCategoryId == VendorCategoryData.Services) {
//       if(spendManagedById == SpendManagedByData.GroupProcurement){
//          return [App_Roles.NMRPPillarLead, App_Roles.NMRPProcurementDirector];
//       } else if(spendManagedById == SpendManagedByData.SBU){
//          return [App_Roles.HodApprover, App_Roles.SBUFinance];
//       }
//    } else {
//       return [App_Roles.HodApprover,App_Roles.ExCo]
//    }
// };

const getApproverLable = (appRoleId: number) => {
   let text = "Approvers";
   if(appRoleId == App_Roles.HodApprover) text = translation.vendor_crete_form1_hod_approver_lbl;
   else if (appRoleId == App_Roles.ExCo) text = translation.vendor_crete_form1_exco_approver_lbl;
   else if (appRoleId == App_Roles.SBUSCHead) text = translation.vendor_crete_form1_sbu_approver_lbl;
   else if (appRoleId == App_Roles.GSSCCategoryLead) text = translation.vendor_crete_form1_CatLead_approver_lbl;
   else if (appRoleId == App_Roles.BusinessDirector) text = translation.vendor_crete_form1_Business_Director_approver_lbl;
   else if (appRoleId == App_Roles.NMRPCategoryManager) text = translation.vendor_crete_form1_Category_Manager_approver_lbl;
   else if (appRoleId == App_Roles.NMRPHead) text = translation.vendor_crete_form1_NMRP_Head_approver_lbl;
   else if (appRoleId == App_Roles.NMRPPillarLead
         || appRoleId == App_Roles.ServicePillarLead) text = translation.vendor_crete_form1_Pillar_Lead_approver_lbl;
   else if (appRoleId == App_Roles.NMRPProcurementDirector
         || appRoleId == App_Roles.ServiceProcurementDirector) text = translation.vendor_crete_form1_Procurement_Director_approver_lbl;
   else if (appRoleId == App_Roles.SBUFinance) text = translation.vendor_crete_form1_sbu_finance_approver_lbl;
   return text;
};

const getApprover1And2 = (users: User[], companyCode: string, workflowApprovals: WorkflowApproval[]) : Approver1n2Data => {
   let wfApprover1s = workflowApprovals.filter(v => v.sequenceId == 1 && v.isRequestApprovers);
   let wfApprover2s = workflowApprovals.filter(v => v.sequenceId == 2 && v.isRequestApprovers);

   let approver1List: User[] = [];
   let approver2List: User[] = [];
   let approver1Lable: string = "";
   let approver2Lable: string = "";

   if(wfApprover1s && wfApprover1s.length > 0) {
      let approver1RoleId = wfApprover1s[0].roleId;
      let approver2RoleId = (wfApprover2s && wfApprover2s.length > 0) ? wfApprover2s[0].roleId : null;
      

      users.forEach((u) => {
         let userCompany = u.userCompanies.find((c) => {
            return c.companyCode == companyCode;
         }) as UserCompany;
         if (userCompany.roleIds.find((r => { return r === approver1RoleId; }))) {
            approver1List.push(u);          
         }
         if (approver2RoleId && userCompany.roleIds.find((r => { return r === approver2RoleId; }))) {
            approver2List.push(u);
         }
      });
      approver1Lable = approver1RoleId ? getApproverLable(approver1RoleId) : "";
      approver2Lable = approver2RoleId ? getApproverLable(approver2RoleId) : "";
   } 

   return {
      approver1Lable: approver1Lable,
      approver2Lable: approver2Lable,
      approver1List: approver1List,
      approver2List: approver2List
   }
};

// const getApprover1And2 = (users: User[], companyCode: string, vendorCategoryId: number
//    , onBoardReasonIds: number[], isBulk: boolean, spendManagedBy: number | null ) : Approver1n2Data => {
//    let approverRoles: App_Roles[] | undefined = [];  
//    if(companyCode) {
//       approverRoles = getApproverRoles(vendorCategoryId, onBoardReasonIds, isBulk, spendManagedBy);
//    }
//    let approver1List: User[] = [];
//    let approver2List: User[] = [];
//    let approver1Lable: string = "";
//    let approver2Lable: string = "";

//    if(approverRoles && approverRoles.length > 0) {
//       let approver1Role = approverRoles[0];
//       let approver2Role = approverRoles.length > 1 ? approverRoles[1] : null;
      

//       users.forEach((u) => {
//          let userCompany = u.userCompanies.find((c) => {
//             return c.companyCode == companyCode;
//          }) as UserCompany;
//          if (userCompany.roleIds.find((r => { return r === approver1Role; }))) {
//             approver1List.push(u);          
//          }
//          if (approver2Role && userCompany.roleIds.find((r => { return r === approver2Role; }))) {
//             approver2List.push(u);
//          }
//       });
//       approver1Lable = approver1Role ? getApproverLable(approver1Role) : "";
//       approver2Lable = approver2Role ? getApproverLable(approver2Role) : "";
//    } 

//    return {
//       approver1Lable: approver1Lable,
//       approver2Lable: approver2Lable,
//       approver1List: approver1List,
//       approver2List: approver2List
//    }
// };

const isInnovationOrNominated = (onBoardReasonIds: number[]) => {
   return (onBoardReasonIds && onBoardReasonIds.find(v => v == VendorOnBoardingReasonData.CustomerNominated 
      || v == VendorOnBoardingReasonData.Innovation)) ? true : false;
};

const getApproverData = (companyCode: string, vendorCategoryId: number, onBoardReasonIds: number[], 
   isBulk: boolean, spendManagedById: number | null, requestTypeId: number,
   approverHandler: (approver1n2Data: Approver1n2Data) => any
 ) => {
   //get workflow approvals
   return RequestService.GetWorkflowApprovals(vendorCategoryId, isBulk, isInnovationOrNominated(onBoardReasonIds), requestTypeId, spendManagedById,
      (workflowApprovals: WorkflowApproval[]) => {
         let selectebleWorkflowApprovals = workflowApprovals && workflowApprovals.filter(v => v.isRequestApprovers);
         let roleIds = (selectebleWorkflowApprovals && selectebleWorkflowApprovals.length > 0 )
            ? selectebleWorkflowApprovals.map(v => v.roleId)
            : [];
         if(roleIds && roleIds.length > 0){
            return MasterDataService.getUsersByRoles(
               companyCode,
               roleIds,
               function (users: User[]) {
                  approverHandler(getApprover1And2(users, companyCode, selectebleWorkflowApprovals));
               },
               function (error: Error) {
                  approverHandler({ approver1Lable: "", approver2Lable: "", approver1List: [], approver2List: []});
               }
            );
         } else {
            approverHandler({ approver1Lable: "", approver2Lable: "", approver1List: [], approver2List: []});
            return Promise.resolve();
         }   

      },
      (error: Error) => {
         approverHandler({ approver1Lable: "", approver2Lable: "", approver1List: [], approver2List: []});
      }
   );
};

export const ApprovalPointUtil = {
    isInitialVendorDetailMode,
    isVendorAprovalEnable,
    isCallOverVerification,
    isDownloadAttachementEnable,
    isUrgentAproveDisplay,
    isOtherFinaceCreateorAmend,
    isSAPCreateOrAmendOrExtend,
    isUserPermitedApprovalPoint,
    isRequestApprovable,
    getUserPermitedApprovalPoint,
    isAdmin,
    isCallerVerificationDone,
    isCheckListApplicable,
    isCallOverVerificationAny,
    isSupportDocumentAny,
    isTeamLeadAny,
    isOnlyObserver,
    isSBUSCHeadOrGSSCLead,
    isUserPermitedRole,
    isRmNonRMServiceApprover1,
    isRmNonRMService,
    isRmNonRMServiceLegatoTL,
    isCustomerNominatedOrInnovation,
    isOnboardingReasonAllowed,
    getApproverData
}